console.log('🚀 [LoginButton.jsx] Ładowanie LoginButton');

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const JEDNOSTKI = '/jednostki';
import { api } from '../utils/api';

console.log('✅ [LoginButton.jsx] Importy załadowane');

function LoginButton() {
  console.log('🎨 [LoginButton.jsx] Renderowanie LoginButton');
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  
  useEffect(() => {
    const checkAuth = async () => {
      console.log('🔐 [LoginButton.jsx] Sprawdzam czy użytkownik jest zalogowany (via API)...');
      
      try {
        // Try to get user data - if cookie exists and is valid, this will succeed
        const data = await api.get('/api-me');
        if (data.user) {
          console.log('🔐 [LoginButton.jsx] Użytkownik zalogowany - auto redirect do /jednostki');
          navigate(JEDNOSTKI);
          return;
        }
      } catch (error) {
        console.log('🔐 [LoginButton.jsx] Użytkownik niezalogowany:', error.message);
      }
      
      setChecking(false);
      console.log('🔐 [LoginButton.jsx] Pokazuję stronę logowania');
    };
    
    checkAuth();
  }, [navigate]);
  
  const handleLogin = () => {
    console.log('🔐 [LoginButton.jsx] Kliknięto przycisk logowania');
    window.location.href = '/.netlify/functions/oauth-start';
  };
  
  // Show loading while checking auth
  if (checking) {
    return (
      <div className="login-screen">
        <div className="login-main">
          <div className="loading">Sprawdzanie autoryzacji...</div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="login-screen">
      {/* Header */}
      <header className="login-header-bar">
        <div className="login-header-inner">
          <div className="logo">
            <img 
              src="https://cdn.discordapp.com/icons/1423017948582252686/bddd09dc3593933ee012741c09ccf6af.webp?size=128" 
              alt="Logo" 
              className="logo__img"
            />
            <span className="logo__text">San Andreas<span className="logo__dot">.</span>National Guard</span>
          </div>
        </div>
      </header>

      {/* Login Card */}
      <main className="login-main">
        <section className="login-card-section">
          <div className="login-card">
            <div className="login-card__glow"></div>
            <div className="login-card__content">
              <div className="login-card__icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                  <polyline points="10 17 15 12 10 7"></polyline>
                  <line x1="15" y1="12" x2="3" y2="12"></line>
                </svg>
              </div>
              <h1 className="login-card__title">Panel MP</h1>
              <p className="login-card__desc">System Rekrutacji i Zarządzania. Zaloguj się przez Discord, aby uzyskać dostęp do <strong>Podań</strong> i <strong>Skarg</strong>.</p>
              
              <button onClick={handleLogin} className="btn btn--primary btn--lg login-card__btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"></path>
                </svg>
                Zaloguj przez Discord
              </button>

              <div className="login-card__info">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                Po zalogowaniu automatycznie dołączysz do serwera Discord
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="login-footer">
        <div className="login-footer__content">
          <p className="login-footer__text">Military Police — System Rekrutacji i Zarządzania</p>
          <div className="credit">
            Created by <a href="https://herbatniczek.online/bio">herbatniczek0</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LoginButton;
